import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";
import { Text } from "./Text";
import { Button } from '../FormControls/Button';
import { ScreenControl } from "../app/ScreenControl";
import { ArrowBackIos , Person, AccountBalance, Receipt } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux';
import { jump } from "../../../main/slices/routerSlice";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";
import {
  setPos,
  setGroup,
  setStoreName,
  setCountrySrore,
  setCurrencyStore,
  setIdStore
} from "../../../main/slices/storeSlice";

const RenderList = ({ classes, items, onSelect }) => {
    const contClass = containerClasses();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const [cookies, setCookies] = useCookies(["source", "idTrxEditing"]);
    const state = useSelector(({ user }) => user);

    const handleProcedure = (type) => {
      setCookies("procedure", type, { path: "/" });
      setCookies("registerFromList", true, { path: true });
      if (type === "register") {
        dispatch(jump({ current: 2, direction: "forward", }));
      }

      return true;
    };

    const handleItemChange = async (item) => {
      console.log("item: ", item);
      setSelected(item.id);
      onSelect(item.id);

      let group= item.group;
      let pos= item.pos;
      let id= item.id;
      let name= item.name;
      let currency= item.currency;
      let country= item.country;

      //SETO LOS DATOS DE LA TIENDA
      dispatch(setPos({ value: pos, error: false }));
      dispatch(setIdStore({ value: id, error: false }));
      dispatch(setGroup({value: group, error: false }));
      dispatch(setStoreName({ value: name, error: false }));
      dispatch(setCountrySrore({value: country, error: false }));
      dispatch(setCurrencyStore({ value: currency, error: false }));

      //INICIO SESION
      dispatch(jump({ current: 8, direction: "forward", }));
    }
    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");

    if(!items.length){
        return (
          <>
            <div style={{ marginBottom: "18rem" }}></div>
            <Fragment>
                <Text classes={["center", "mediumText", "alignContent"]}>Aún no cuentas con comerciós.</Text>
                <div style={{ marginBottom: "10rem" }}></div>
                <ScreenControl 
                  btncolor={"cobrarBtn"}
                  btnText={"Crear Comercio"}
                  index={{fw: 2 }}
                  beforeSubmit={() => handleProcedure("register")}
                  disabled={false} 
                  />
            </Fragment>
            <Button 
                style={{
                    position: "fixed",
                    top: "1.5rem",
                }} 
                classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                onClick={() => dispatch(jump({ current: 0, direction: "backward" })) }>
                <ArrowBackIos  fontSize='small' />
            </Button>
          </>
        );
    }

    useEffect(() => {
        if (cookies.idTrxEditing && cookies.idTrxEditing !== "" && !selected) {
          setSelected(cookies.idTrxEditing);
          setCookies("idTrxEditing", "");
        }
    }, [cookies.idTrxEditing, selected]);

    return (
      <>
        <Fragment>
          <div style={{ padding: "0 0.2rem" }}>
              <Text classes={["title", "center"]}> {""} Comercios {""}</Text>
              <div style={{ width: "100%", height: "25.5rem", overflowY: "scroll"}}>
                  {items.map((item, i) =>
                      <div key={i} onClick={() => handleItemChange(item)} className={`${contClass.listTransactions} ${item.id === selected ? contClass.selectedItem : ""}`}>
                          <div className={contClass.width100}>
                            <Text classes={["annotation"]}>Nombre Del Comercio</Text>
                            <Text style={{color:"rgba(108, 133, 137, 1)", fontWeight: "bold"}} classes={["mediumText"]}>{item.storeName}</Text>
                            <Text classes={["annotation"]}>{`${item.id}`}</Text>
                          </div>
                          <div className={contClass.maxWidth20} style={{textAlign: "right", whiteSpace: "nowrap"}}>
                            <Text classes={["annotation"]}>Registro</Text>
                            <Text style={{color:"rgba(108, 133, 137, 1)", fontWeight: "bold"}} classes={["mediumText"]}>{item.pos}</Text>
                          </div>
                      </div>
                  )}
              </div>
          </div>
          <div style={{ marginBottom: "1rem" }}></div>
          <ScreenControl 
            btncolor={"registerBtn"}
            btnText={"Crear Comercio"}
            index={{fw: 3 }}
            beforeSubmit={() => handleProcedure("register")}
            disabled={false} 
          />
        </Fragment>                                                         
        <Button 
            style={{
                position: "fixed",
                top: "1.5rem",
            }} 
            classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
            onClick={() => dispatch(jump({ current: 0, direction: "backward" })) }
        >
            <ArrowBackIos />
        </Button>
      </>
    );
}

export const ListStores = ({ classes = [], items = [], onSelect = () => {} }) => (
    <RenderList {...{ classes, items, onSelect }} />

);